import { render, staticRenderFns } from "./CustomShapeTemplate.vue?vue&type=template&id=e016616e&scoped=true&"
import script from "./CustomShapeTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomShapeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CustomShapeTemplate.vue?vue&type=style&index=0&id=e016616e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e016616e",
  null
  
)

export default component.exports